// extracted by mini-css-extract-plugin
export default {"loader":"loader_b70bb"};